import { render } from "./MediaDialog.vue?vue&type=template&id=8dbca73c&scoped=true"
import script from "./MediaDialog.vue?vue&type=script&lang=js"
export * from "./MediaDialog.vue?vue&type=script&lang=js"

import "./MediaDialog.vue?vue&type=style&index=0&id=8dbca73c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dbca73c"]])

export default __exports__